import React from "react"
import { Transformation } from "cloudinary-react"
import DfbAnchor from "../ui-kit/dfb_anchor"
import DfbImage from "../ui-kit/dfb_image"
import { formatDate } from "../utilities"
import { useTranslations } from "../../hooks/useTranslations"
import { useGetNewsImage } from "../../hooks/useNewsFallbackImage"

function CCardNews({ data }) {
  const t = useTranslations()
  const getNewsImage = useGetNewsImage()

  let overline = data.tx_headless_news_date
    ? formatDate(new Date(data.tx_headless_news_date))
    : ""

  if (data.content.main_category?.title) {
    overline += " // " + data.content.main_category.title
  }

  if (data.category_overline) {
    if (overline) {
      overline += " // "
    }
    overline += data.category_overline
  }

  return (
    <a className="dfb-Card m-CardNews-card" href={data.full_slug} data-testid={`news-card-${data.uid}`}>
      <div className="dfb-Card-imageContainer">
        <DfbImage
          image={getNewsImage(data)}
          aspect_ratio="16:9"
          add_class="m-CardGrid-image"
        >
          <Transformation
            crop="fill"
            gravity="faces:center"
            width="720"
            height="405"
            quality="auto"
            fetchFormat="auto"
          />
        </DfbImage>
      </div>

      <div className="dfb-Card-content">
        {overline && <div className="dfb-Card-topline" data-testid="news-main-category">{overline}</div>}
        {data.content.title && (
          <h4 className="dfb-Headline dfb-Card-headline" data-testid="news-title">
            {data.content.title}
          </h4>
        )}
        {data.content.tx_headless_news_teaser && (
          <p className="dfb-Paragraph dfb-Card-description" data-testid="news-teaser">
            {data.content.tx_headless_news_teaser}
          </p>
        )}
      </div>
      <div className="dfb-Card-footer" data-testid="news-footer-load-more">
        <DfbAnchor
          tagName="span"
          secondary
          href={data.full_slug}
          text={t("dfb_anchor.loadmore")}
        />
      </div>
    </a>
  )
}

export default CCardNews
